


































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldDemographics'

  vue:
    props: ['value', 'errors']

    data: ->
      demographics: @value

    computed:
      demographicsPrototype: ->
        gender:
          female: ''
          male: ''
        age:
          '<18': ''
          '18-24': ''
          '25-34': ''
          '35-44': ''
          '45-54': ''
          '55+': ''
        ethnicity:
          african: ''
          asian: ''
          hawaiian: ''
          hispanic: ''
          native_American: ''
          white: ''
          multiple: ''
          other: ''

    mounted: ->
      @initializeDemographics()

    methods:
      hiInputChange: ->
        @$emit 'input', @demographics

      initializeDemographics: ->
        return unless @isEmptyValue @demographics
        @demographics = JSON.parse(JSON.stringify(@demographicsPrototype))
        @$emit 'input', @demographics

      percentageOptions: (_, cb) ->
        cb([...Array(100).keys()].map((v) -> ({ value: String(v + 1) })))

export default VueOptions.vue settings
